import React from 'react';
import './PageSpinner.css';

const PageSpinner = ({ minHeight = '50vh' }) => (
  <div className="ps-wrap" style={{ minHeight }}>
    <div className="ps-ring" role="status" aria-label="Loading" />
  </div>
);

export default PageSpinner;
